import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import ActivityContainer from 'components/Common/ActivityContainerTable';
import { AppDispatch, RootState } from 'redux/store';
import MuiLoader from 'components/Common/Loader';
import routes from 'constants/routes';
import { dateFormat, formatAmount, timeFormat } from 'utils/helpers';
import { useEffect } from 'react';
import { fetchHistory } from 'redux/slices/history/HistorySlice';
import ActivityHeader from 'components/Common/activity/ActivityHeader';
import { ParishionerActivityHeaderProps } from 'types/community';
import { Typography } from '@mui/material';

const columns = [
    { id: 'transactionDate', label: 'Date', render: ({ data }: any) => dateFormat(data?.['transactionDateTime']) },
    { id: 'transactionTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.['transactionDateTime']) },
    {
        id: 'to',
        label: 'To',
        render: ({ data }: any) => {
            const userName = data?.user?.name;
            const eventName = data?.event?.name;
            const eventType = data?.type;
            if (eventType === 'CONTRIBUTE') {
                return eventName;
            }
            return userName || '';
        },
    },
    { id: 'transactionStatus', label: 'Status' },
    {
        id: 'amount',
        label: 'Total',
        render: ({ value, data }: any) => {
            let prefix = '+';
            const eventType = data?.type;
            if (eventType === 'CONTRIBUTE') {
                prefix = '-';
            } else if (data?.transactionStatus === 'FAILED') {
                prefix = '';
            }
            return <Typography>{prefix + formatAmount(value)}</Typography>;
        },
    },
];
const activityHeaderFields = (props: ParishionerActivityHeaderProps) => {
    const { lastTithe, totalTithe } = props;
    return [
        {
            endAdornmentValue: lastTithe,
            value: 'Last Tithe',
        },
        {
            endAdornmentValue: totalTithe,
            value: 'Total ',
        },
    ];
};

const ParishionerActivityContainer = () => {
    const navigate = useNavigate();
    const { records, loading, totalCount, lastTithe } = useSelector((state: RootState) => state.history || {});
    const { tableState } = useSelector((state: RootState) => ({ tableState: state.app.table }));
    const dispatch = useDispatch<AppDispatch>();
    const params = useParams();
    const { uuid } = params || {};
    useEffect(() => {
        uuid && dispatch(fetchHistory({ uuid, offset: tableState.offset }));
    }, [dispatch, uuid, tableState.offset]);

    const navigationHandler = (row: any) => {
        navigate(routes.transaction.main.replace(':id', row?.confirmationCode.toString()), { state: { type: 'community' } });
    };

    const lastTitheDate = lastTithe?.transactionDateTime;
    const activityHeaderProps = {
        lastTithe: lastTitheDate ? dateFormat(lastTitheDate) : '',
        totalTithe: totalCount,
    };
    return (
        <>
            <MuiLoader absolute loading={loading} />
            <ActivityContainer
                navigationHandler={navigationHandler}
                records={records}
                columns={columns}
                disabledDateFilter
                totalCount={totalCount}
                serverSidePagination
                defaultPagination={false}
                activityHeader={<ActivityHeader fields={activityHeaderFields(activityHeaderProps)} />}
            />
        </>
    );
};

export default ParishionerActivityContainer;
